/* eslint-disable max-lines-per-function */
import React from 'react'
import { authFetch } from '~/services/fetch'

export async function getDispatchByDispatchGroup({
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  endDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  groupSetId,
  operationUnitId,
  phone,
  requester,
  userId,
  geographicAreas,
  districtIds,
  startTime,
  endTime,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/dispatch-by-dispatch-group',
      method: 'POST',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        phone: phone,
        name: requester,
        geographicAreas: geographicAreas,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}

export async function getDispatchByCity({
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  endDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  operationUnitId,
  phone,
  requester,
  userId,
  geographicAreas,
  districtIds,
  startTime,
  endTime,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/dispatch-by-city',
      method: 'POST',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        phone: phone,
        geographicAreas: geographicAreas,
        name: requester,
        userId:userId,
        startTime: startTime,
        endTime: endTime,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}

export async function getDispatchByDistrict({
  agencyId,
  deviceId,
  operationId,
  dispatchGroupId,
  categoryIds,
  typeIds,
  subtypeIds,
  startDate,
  endDate,
  payload,
  consummated,
  statusIds,
  cityIds,
  districtIds,
  groupSetId,
  location,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  operationUnitId,
  phone,
  requester,
  userId,
  geographicAreas,
  startTime,
  endTime,
}) {
  try {
    const { data } = await authFetch({
      url: '/statistics/dispatch-by-district',
      method: 'POST',
      data: {
        agencyId: agencyId,
        deviceId: deviceId,
        operationId: operationId,
        dispatchGroupIds: dispatchGroupId,
        categoryIds: categoryIds,
        typeIds: typeIds,
        subtypeIds: subtypeIds,
        startDate: startDate,
        finishDate: endDate,
        excludeClosed: payload.exludeClosed,
        withSolvedThirdParty: payload.withSolvedThirdParty,
        consummated: consummated,
        statusIds: statusIds,
        cityIds: cityIds,
        districtIds: districtIds,
        groupSetId: groupSetId,
        location: location,
        closedStatusClassId: closedStatusClassId,
        closedStatusId: closedStatusId,
        qualifierOptions: qualifierOptions,
        operationUnitId: operationUnitId,
        phone: phone,
        geographicAreas: geographicAreas,
        name: requester,
        userId: userId,
        startTime: startTime,
        endTime: endTime,
      },
    })

    return data
  } catch (error) {
    throw error
  }
}
